import React from 'react';

import {
	AI_SECTION,
	AI_SECTION_RANK,
	AI_VIEW_SECTION,
	HERO_PROMPT_BUTTON_GROUP,
	TOOLBARS,
} from '@atlaskit/editor-common/toolbar';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { RegisterComponent } from '@atlaskit/editor-toolbar-model';

import type { MalleableUiPlugin } from '../../malleableUiPluginType';
import { RemixButton } from '../components/RemixButton';

const MAUI_REMIX_GROUP = {
	type: 'group' as const,
	key: 'malleable-ui-remix-group',
};

const MAUI_REMIX_BUTTON = {
	type: 'button' as const,
	key: 'malleable-ui-remix-button',
};

export const getSelectionToolbarComponents: (
	api: ExtractInjectionAPI<MalleableUiPlugin>,
) => RegisterComponent[] = (api) => {
	return [
		{
			type: MAUI_REMIX_GROUP.type,
			key: MAUI_REMIX_GROUP.key,
			parents: [
				{
					type: AI_SECTION.type,
					key: AI_SECTION.key,
					rank: AI_SECTION_RANK[HERO_PROMPT_BUTTON_GROUP.key] + 10,
				},
				// View mode (Live Page): AI_VIEW_SECTION
				{
					type: AI_VIEW_SECTION.type,
					key: AI_VIEW_SECTION.key,
					rank: AI_SECTION_RANK[HERO_PROMPT_BUTTON_GROUP.key] + 10,
				},
			],
		},
		{
			type: MAUI_REMIX_BUTTON.type,
			key: MAUI_REMIX_BUTTON.key,
			parents: [
				{
					type: MAUI_REMIX_GROUP.type,
					key: MAUI_REMIX_GROUP.key,
					rank: 100,
				},
			],
			component: ({ parents }) => {
				const onPrimaryToolbar = parents.at(0)?.key === TOOLBARS.PRIMARY_TOOLBAR;
				if (onPrimaryToolbar) {
					return null;
				}
				return <RemixButton api={api} />;
			},
		},
	];
};
